import CartBaseItemView from '../../baseViews/ItemView';
import CartTotalTemplate from '../templates/CartTotalTemplate';
import { cart } from '../config';

const CartTotal = CartBaseItemView.extend({
	JSXTemplate: CartTotalTemplate,
	templateHelpers () {

		const { model } = this;
		const { globals } = window.lp;
		const { isCustomerService } = globals;
		const items = model.get('ProductItems');
		const itemTotal = model && items ? items.reduce((total, current) => current.Quantity + total, 0) : 0;
		const helpers = {
			continueShoppingUrl: cart.continueShoppingUrl,
			isCustomerService,
			csrKioskMode: window.lp.globals.isStoreInSession && window.lp.globals.isCustomerService,
			qty: `${itemTotal} item${itemTotal === 1 ? '' : 's'}`
		};
		return helpers;

	},
	initialize () {

		this.listenTo(this.model, 'change', () => {

			this.render();

		});

	}
});

export default CartTotal;
